import React from 'react'
import { pokemonType } from '../style';
import { withRouter, useHistory, } from "react-router";
import { useState } from 'react/cjs/react.development';

function Box({ pokemon }){
    const hei = pokemon.height/10
    const wei = pokemon.weight/10
    const str = pokemon.name
    const upper = str.charAt(0).toUpperCase() + str.slice(1);
    const num = pokemon.id
    const id = 'No. ' + num.toString().padStart(3, '0')
    const history = useHistory()
    const toPokemonDetail = ()=>{
        history.replace({pathname:`/pokemon/${pokemon.name}`, state:{pokemon}})
      }
      
    return (
        
        
    <>{pokemon.id<891&&
       <div className="Card" onClick={toPokemonDetail}>
            <div className="Card-inner">
            <div className="Card-front">
            <div className="Card_Name">
                {upper}
            </div>
            <div className="Card_Num">
              {id}
            </div>
            <div className="Card_tyes" >
                {pokemon.types.map(type =>{
                    return(
                        <div className="Card_type"  
                        style={{backgroundColor:pokemonType[type.type.name]}}>
                            {type.type.name.charAt(0).toUpperCase() + type.type.name.slice(1)}
                        </div>
                    )
                })}
                </div>
                <div ClassName="Card_img">
                <img className="img" src={pokemon.sprites.front_default} alt="" />
            </div>
            <div className="mini"><img  className="min"src="pok.png" /></div>
                </div>
            <div className="Card-back"> 
                <div>height: {hei}m </div>
                <div>weight: {wei}kg</div>
                <div className="Card_tyes2" >
                {pokemon.types.map(type =>{
                    return(
                        <div className="Card_type"  
                        style={{backgroundColor:pokemonType[type.type.name]}}>
                            {type.type.name.charAt(0).toUpperCase() + type.type.name.slice(1)}
                        </div>
                    )
                })}
                </div>
                <div ClassName = "Card_img2">
                <img className="img2" src={pokemon.sprites.back_default} ></img>
                <div className="mini-2"><img className="min" src="pok.png" /></div>
                </div>
                </div>
                </div>
            </div>
}
            </>
    )
}
export default withRouter(Box);